import React from 'react';
import Modal from '../../components/Modal';
import ModalHeading from '../../components/Modal/ModalHeading';
import ModalForm from '../../components/Modal/ModalForm';
import InputsSection from '../../components/Modal/InputsSection';
import ModalButtons from '../../components/Modal/ModalButtons';

const DeleteIOCModal = ({ data }) => {
	const { deleteIOCModalStatus, closeDeleteModal, handleDeleteIOC } = data;
	return (
		<Modal show={deleteIOCModalStatus.status}>
			<ModalHeading heading={`Delete ${deleteIOCModalStatus.type} Input`} />
			<ModalForm>
				<InputsSection>
					<p className='delete_text'>
						Are you sure, you want to delete{' '}
						<span>
							{deleteIOCModalStatus.type} {deleteIOCModalStatus.data}
						</span>{' '}
						?
					</p>
				</InputsSection>
				<ModalButtons
					submitButtonLabel={`Delete ${deleteIOCModalStatus.type}`}
					onSubmit={handleDeleteIOC}
					cancelButtonLabel='Cancel'
					onCancel={closeDeleteModal}
					style={{ justifyContent: 'flex-start' }}
				/>
			</ModalForm>
		</Modal>
	);
};

export default DeleteIOCModal;
